enum EntryType {
    COMMISSION = 1,
    PERFORMANCE ,
    CONSULTING_BASE,
    BONUS,
    TIPS ,
    HOSTING,
    TRAINING ,
    ADJUSTEMENTS ,
    LEAD_BONUS ,
    BENEFITS ,
    EXPENSES ,
    PROMOTION,
    SALES_TAX
}

export default EntryType


// WEBPACK FOOTER //
// ./js/utils/EntryType.ts